// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; // ✅ Storage
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

// Your Firebase config.
// Values come from REACT_APP_FIREBASE_* env vars when present, and fall back to
// the production project literals when absent — so a production build with no
// env override behaves exactly as before. Staging supplies its own values via
// .env.staging (loaded by the build:staging / start:staging scripts).
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAKhxzGmMvCwWAWyr96oWc-OPgS0d9rA6I",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "regulatory-portal.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "regulatory-portal",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "regulatory-portal.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "38559365078",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:38559365078:web:f537b352587548ea88d677",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-PFMHQCSDGS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// App Check — must run before any Firebase service is used
if (typeof window !== "undefined") {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN || true;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(
      process.env.REACT_APP_RECAPTCHA_ENTERPRISE_KEY || "6LcrBSctAAAAAPXTeyT_66RtOS9Ra6s3vaV3PBUg"
    ),
    isTokenAutoRefreshEnabled: true,
  });
}

// ✅ Export Firestore
export const db = getFirestore(app);
export const auth = getAuth(app);
// Bucket comes from firebaseConfig.storageBucket (env-driven, prod fallback), so
// staging reads/writes its own bucket instead of production's.
export const storage = getStorage(app, `gs://${firebaseConfig.storageBucket}`);
export const functions = getFunctions(app);